module.exports = "/shared/fonts/Futura/web/FtraMd-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/Futura/web/FtraMd-webfont.ttf
// module id = 35
// module chunks = 13